"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1643],{

/***/ 21643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ newsletter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./components/atoms/caption/index.ts + 1 modules
var atoms_caption = __webpack_require__(38959);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
;// CONCATENATED MODULE: ./components/templates/newsletter/Newsletter.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            text-heading text-heading-mobile--h2 lg:text-heading--h2\n            ",
        "\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var VARIANT_MAPS = {
    primary: "text-primary",
    primaryLight: "text-primary-light",
    secondary: "text-secondary",
    tertiary: "text-black",
    alternative: "text-white"
};
var INPUT_MAPS = {
    primary: "border-primary-400 placeholder-primary-400",
    primaryLight: "border-primary-300 placeholder-primary-300",
    secondary: "border-secondary-400 placeholder-secondary-400",
    tertiary: "border-black placeholder-black",
    alternative: "border-white placeholder-white"
};
/**
 * Newsletter
 */ var Newsletter = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, caption = param.caption, desc = param.desc, image = param.image, title = param.title, backgroundColor = param.backgroundColor, legalResume = param.legalResume, linkText = param.linkText, linkUri = param.linkUri, textColor = param.textColor;
    var ref = (0,react.useState)(false), valid = ref[0], setValid = ref[1];
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var t = (0,useTranslation/* default */.Z)("common").t;
    var handlerEmail = function(e) {
        var reg = new RegExp(/^(?=[A-Z0-9@._%+-]{6,254}$)[A-Z0-9._%+-]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,8}[A-Z]{2,63}$/i);
        setEmail(e.target.value);
        if (reg.test(e.target.value)) {
            setValid(true);
        } else {
            setValid(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:flex-row ".concat(VARIANT_MAPS[textColor], " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-36 w-full md:h-56 lg:h-auto lg:w-1/2",
                children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image,
                    layout: "fill",
                    objectFit: "cover",
                    alt: "image NewsLetter"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                method: "POST",
                id: "zcampaignOptinForm",
                action: "https://zcv3-zcmp.maillist-manage.eu/weboptin.zc",
                target: "_zcSignup",
                style: {
                    backgroundColor: "var(--tw-color-".concat(backgroundColor, ")")
                },
                className: "flex flex-col gap-3 px-5 py-10 md:gap-5 md:p-12 md:pr-[max(1.25rem,_calc((100%_-_var(--wrapper-size)_+_2.5rem)_/_2))] lg:w-1/2",
                children: [
                    caption && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_caption/* default */.Z, {
                        variant: textColor,
                        children: caption
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (0,es/* oneLine */.f9)(_templateObject(), caption ? "md:mt-4" : ""),
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-heading-mobile--h5 text-heading mt-2 lg:text-heading--h5 md:mt-0",
                        children: desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "mt-8 flex flex-col gap-3 md:mt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-other text-other--label-form ".concat( true && "!text-white"),
                                children: "EMAIL:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                style: {
                                    backgroundColor: "var(--tw-color-".concat(backgroundColor, ")")
                                },
                                onChange: function(e) {
                                    return handlerEmail(e);
                                },
                                className: " border-b ".concat(INPUT_MAPS[textColor], " border-l-0 border-r-0 border-t-0  outline-none placeholder:opacity-60"),
                                type: "email",
                                placeholder: t("components.templates.newsLetter.placeholder"),
                                id: "EMBED_FORM_EMAIL_LABEL",
                                value: email,
                                name: "CONTACT_EMAIL"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-14",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            as: "button",
                            type: "submit",
                            disabled: !valid,
                            size: "large",
                            variant:  true ? "outline" : 0,
                            children: t("components.templates.newsLetter.send")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "fieldBorder",
                        value: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "zc_trackCode",
                        id: "zc_trackCode",
                        value: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "viewFrom",
                        id: "viewFrom",
                        value: "URL_ACTION"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "submitType",
                        name: "submitType",
                        value: "optinForm_save"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "lD",
                        name: "lD",
                        value: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "emailReportId",
                        id: "emailReportId",
                        value: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "listId",
                        name: "listId",
                        value: "152629000000028201"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "mandatoryListId",
                        name: "mandatoryListId",
                        value: "152629000000028201"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "zx",
                        id: "cmpZuid",
                        value: "14ad9be886"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "zcvers",
                        value: "2.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "oldListIds",
                        id: "allCheckedListIds",
                        value: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "mode",
                        name: "mode",
                        value: "OptinCreateView"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "zcld",
                        name: "zcld",
                        value: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "zctd",
                        name: "zctd",
                        value: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "document_domain",
                        value: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "zc_Url",
                        value: "zcv3-zcmp.maillist-manage.eu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "new_optin_response_in",
                        value: "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "duplicate_optin_response_in",
                        value: "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "zc_formIx",
                        name: "zc_formIx",
                        value: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "zc_formIx",
                        name: "zc_formIx",
                        value: "3za4158b754670f84a7f43d4743c996838a118a0980548c8de51942828cc258ee2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "viewFrom",
                        value: "URL_ACTION"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        id: "scriptless",
                        name: "scriptless",
                        value: "yes"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-other text-other--detail",
                        children: [
                            legalResume && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "newsletter-html font-light [&>a]:text-tertiary-400",
                                dangerouslySetInnerHTML: {
                                    __html: legalResume
                                }
                            }),
                            linkUri && linkText && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                passHref: true,
                                prefetch: false,
                                href: linkUri,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                    className: "!text-other !text-other--detail !inline w-fit ".concat("apartments" === "apartments"),
                                    variant: textColor,
                                    children: linkText
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
Newsletter.displayName = "Newsletter";

;// CONCATENATED MODULE: ./components/templates/newsletter/index.ts

/* harmony default export */ var newsletter = (Newsletter);


/***/ })

}]);